import { usePortalContext } from '@/contexts/PortalProvider';
import { useCommonTranslation } from '@/hooks/useCommonTranslation';
import PageHeader from '@/components/controls/PageHeader';

interface PassengerHeaderProps {
  name: string;
  createDisabled: boolean;
  createHidden?: boolean;
  onCreateTrip: () => void;
}

export default function PassengerHeader({
  name,
  createDisabled,
  createHidden,
  onCreateTrip,
}: PassengerHeaderProps) {
  const t = useCommonTranslation();
  const { isClientPortal } = usePortalContext();

  const returnLinkText = isClientPortal
    ? t('passenger.searchTitle')
    : t('common.back');

  return (
    <PageHeader
      title={name}
      returnLink="/passengers"
      returnLinkText={returnLinkText}
      primaryActionText={createHidden ? undefined : t('passenger.createTrip')}
      primaryActionDisabled={createDisabled}
      primaryActionDataFsElement="CreateReservationStartButton"
      onPrimaryAction={onCreateTrip}
    />
  );
}
